// src/components/SeoHreflang.jsx
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams } from 'react-router-dom';

const HOST = 'https://best-practices.online';
const LOCALES = ['ru','en','es','zh'];

export default function SeoHreflang() {
  const { pathname } = useLocation();
  const { lang } = useParams();

  // заменяем текущий префикс на каждый из поддерживаемых
  const pathWithoutLang = pathname.replace(/^\/(ru|en|es|zh)(?=\/|$)/, '').replace(/\/+$/, '');
  const normalized = pathWithoutLang || ''; // '' для корня

  return (
    <Helmet>
      {LOCALES.map(l => (
        <link
          key={l}
          rel="alternate"
          hrefLang={l}
          href={`${HOST}/${l}${normalized || ''}${normalized && !normalized.endsWith('/') ? '' : ''}`}
        />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${HOST}/`} />
    </Helmet>
  );
}
